var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndividualTagTwoTone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.5C1 10.3685 1.05792 10.1794 1.33413 9.92446C1.61713 9.66327 2.05712 9.40602 2.62093 9.18016C3.75017 8.72779 5.12376 8.5 6 8.5C6.87624 8.5 8.24983 8.72779 9.37907 9.18016C9.94288 9.40602 10.3829 9.66327 10.6659 9.92446C10.9421 10.1794 11 10.3685 11 10.5V11H1V10.5ZM8 3C8 4.10522 7.10522 5 6 5C4.89478 5 4 4.10522 4 3C4 1.89478 4.89478 1 6 1C7.10522 1 8 1.89478 8 3Z",
    fill: "#DADADA",
    stroke: "#999999",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividualTagTwoTone);
export default __webpack_public_path__ + "static/media/individual-tag-two-tone.9b26fc1afb6e8aa0785d3caca63736d9.svg";
export { ForwardRef as ReactComponent };